export const NON_STAFF_NAMES = ["Non Staff", "Non-Staff", "NON_STAFF",  "NON STAFF", "non staff", "non-staff", "non_staff"];
